import { cloneElement, memo, useMemo } from 'react';

import type { FC, HTMLAttributes, ReactElement } from 'react';

export interface AnimatedSegmentProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactElement;
  start?: number;
  end?: number;
  progress?: number;
}

const AnimatedSegment: FC<AnimatedSegmentProps> = (props) => {
  const { children, start = 0, end = 100, progress, ...restProps } = props;
  const range = end - start;
  const distance = progress - start;

  const elemProgress = useMemo(() => {
    if (progress <= start) return 0;
    if (progress >= end) return 100;
    const unitValue = 100 / range;
    return Number((distance * unitValue).toFixed(3));
  }, [distance, range, start, end, progress]);

  return (
    <div {...restProps}>
      {cloneElement(children, {
        ...children.props,
        progress: elemProgress,
      })}
    </div>
  );
};

export default memo(AnimatedSegment);
